import React, { useEffect, useState } from 'react';
import { checkLink, makeAssetLink, makeCompanyCopyright } from '../utils/helpers';
import { externalAssetNames, urlsMap } from '../utils/constants';
import { useSelector } from 'react-redux';

const styles = {
  container: {
    marginTop: 'auto',
    paddingBottom: 8,
    textAlign: 'center',
  },
  divider: {
    borderColor: 'transparent',
  },
  text: {
    fontSize: 12,
    padding: 5,
  },
  link: {
    color: '#4183c4',
  },
};
/* 2024.11 NOTE:  This component is not visible if Hyperlane is enabled */
const Footer = () => {
  const customerPlatformLink = useSelector(reduxState => reduxState.entities.customerPlatformLink)
  
  return (
    <div style={styles.container}>
      <hr style={styles.divider} />
      <p style={styles.text}>
        {makeCompanyCopyright()}
        {` | `}
        <a
          href={customerPlatformLink}
          target="_blank"
          rel="noreferrer"
          style={styles.link}
        >
          Platform Terms of Use
        </a>
        {` and `}
        <a
          href={urlsMap.get('PLATFORM_PRIVACY_POLICY')}
          target="_blank"
          rel="noreferrer"
          style={styles.link}
        >
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default Footer;
